import TrayWrapper from "./TrayWrapper";

export default TrayWrapper;
